import { useContext } from "react";

import { LayoutContext } from "@/components/LayoutProvider";
import Nudge from "@/components/Nudge";
import { Paragraph } from "@/components/Typography";
import { brandName } from "@/config/brand";
import SidebarChrome from "@/conversation/sidebar/SidebarChrome";
import SidebarSignin from "@/conversation/sidebar/SidebarSignin";
import { useCurrentConversationId } from "@/hooks/conversation";

export default function OutreachNudge() {
  const currentConversationId = useCurrentConversationId();
  const { setModalContent } = useContext(LayoutContext);

  const handleSignin = () => {
    setModalContent(
      () => (props: { onClose: () => void }) => (
        <SidebarChrome {...props} dataTrackingIdPrefix="nudge-signin">
          <SidebarSignin
            conversationId={currentConversationId}
            onContinue={() => setModalContent(null)}
          />
        </SidebarChrome>
      ),
      { width: 400 },
    );
  };

  return (
    <Nudge
      key="outreach"
      title="Stay on track with free reminders and follow-ups"
      description={
        <Paragraph size="$sm" color="$textSecondary">
          Create a free account so {brandName} can send reminders and follow-ups
          by text.
        </Paragraph>
      }
      primaryAction={{
        label: "Create free account",
        onPress: handleSignin,
        dataTrackingId: "soft-nudge-create-free-account",
      }}
      secondaryAction={{
        label: "Log in",
        onPress: handleSignin,
        dataTrackingId: "soft-nudge-log-in",
      }}
      dismissTrackingId="soft-nudge-dismissed"
    />
  );
}
